import React from 'react';

import './SingleLayout.scss';

const SingleLayout: React.FC = ({ children }) => {
  return <div className="single-layout-root">{children}</div>;
};

export default SingleLayout;
